import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setToken } from "@/lib/api";
import { disablePush } from "@/lib/push";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(false);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // Returning from Google OAuth — let AuthCallback exchange the session_id first.
        if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
        refresh();
    }, [refresh]);

    const login = async (identifier, password) => {
        const { data } = await api.post("/auth/login", { identifier, password });
        setToken(data.token);
        await refresh();
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setToken(data.token);
        await refresh();
        return data;
    };

    const logout = async () => {
        try { await disablePush(); } catch { /* ignore */ }
        try { await api.post("/auth/logout"); } catch { /* ignore */ }
        setToken(null);
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
